import { type FC, useContext } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import FormButton from './sharedComponents/FormButton.tsx';
import SellerFormContext from './SellerFormContext.tsx';

import classnames from 'classnames';
import dibsCss from 'dibs-css';

const SellerApplicationFormBusinessIntro: FC = () => {
    const { dispatch } = useContext(SellerFormContext);

    return (
        <div className={dibsCss.mbLarge} data-tn="application-form-business-intro">
            <div className={dibsCss.wFull}>
                <div className={classnames(dibsCss.sassyFontBody, dibsCss.mbLarge)}>
                    <FormattedMessage
                        defaultMessage="Thank you for expressing interest in joining the 1stDibs marketplace! We look forward to learning more about your business through this application."
                        id="SellerApplicationForm.businessIntro.p1"
                    />
                </div>
                <div className={classnames(dibsCss.sassyFontBody, dibsCss.mbLarge)}>
                    <FormattedMessage
                        defaultMessage="The application will take about 10 minutes to complete and you will need to provide general details about your business in addition to an inventory sample of 5 pieces including photo, description, price, and provenance details."
                        id="SellerApplicationForm.businessIntro.p2"
                    />
                </div>
                <FormButton
                    isLoading={false}
                    onSubmit={() => dispatch({ type: 'SET_STEP', step: 'BUSINESS_STEP1' })}
                />
            </div>
        </div>
    );
};

export default SellerApplicationFormBusinessIntro;
